<template>
   <div id="page">
      <site-header title="Engineering Enablement Command"></site-header>
      <div class="content-row">
         <h1>
            Engineering Enablement Command (EEC)
         </h1>
         <p>
            With large organizations taking on a multitude of software and technology initiatives to transform their organizations and augment their services, decision makers are faced with a host of underlying challenges that mirror product and engineering requirements normally associated with those of the top-tier tech companies.
         </p>

         <p>
            Mobkast offers organization leaders a path to gracefully supercharge their transformation and growth efforts by offloading tough engineering problems to Mobkast's Engineering Enablement Command (EEC). EEC allows organizations to free up talent within customer organizations to focus primarily on the important work that is specific to the organization's unique offerings.
         </p>

         <p>
            EEC lets teams <span class='focus-bit'>offload important considerations with regards to building and maintaining business critical systems, technology infrastructure and engineering processes</span>. This includes data ingestion pipelines, massively parallel compute engines, data storage and query optimization, cloud deployment and automation, third-party integrations, configuration management, information security and operational monitoring. The elite team of engineers at the EEC have successfully delivered on such transformational undertakings at growing and large organizations alike.
         </p>

         <p>
            Mobkast's EEC is exceptional in its offering as it put strong emphasis on a direct customer interface with its architects and engineers at all stages of its customer engagement. This maximizes engagement efficacy and has been a principle element of the EEC members' approach to delivering on enablement projects involving substantial technical and organizational complexity.
         </p>   

         <p>
            Due to a limited nature of the talent sought after by Mobkast for the EEC, engagement is subject to availability. However, once engaged EEC offers a dedicated team to solidify your company's future-ready technical core that is otherwise costly to attain and even costlier to ignore.
         </p>
         <br>
         <p>
            To learn more about the Engineering Enablement Command reach out to <b>team@mobkast.com</b>.
         </p>
      </div>
      <site-footer></site-footer>
   </div>
</template>

<script>
export default {
   data () {
      return {
         msg: ''
      }
   },
   methods: {
      preventMouseDown: (e) => {}
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#page {
   height: auto;
   width: 64rem;
   margin: auto;
   font-size: 0.94rem;
   margin-bottom: 6rem;
}

.content-row {
   margin: auto;
   width: 86%;
}

.focus-bit {
   font-weight: 500;
}

h1 {
   margin: 4rem 4rem;
}


/* + Site Wide */
a, u {
    text-decoration: none;
}

a {
   color: #888888;
}
/* - Site Wide */

/* + Responsive UI */
@media screen and (max-width: 1040px) {
   #page { 
      width: auto;
   }
}

@media screen and (max-width: 740px) {
   #page { 
      width: auto;
   }

   h1 {
      margin: 2rem 1rem;  
      font-size: 1.6rem; 
   }

   h2 {
      font-size: 1.3rem; 
   }

   h3 {
      font-size: 1rem; 
   }
}

@media screen and (max-width: 480px) {
   #page { 
      width: auto;
   }
}
/* - Responsive UI */
</style>



// WEBPACK FOOTER //
// src/components/site/EEC.vue